var map = {
	"./BMI.jpg": "FFLX",
	"./Body_temp.jpg": "aO+T",
	"./Fasting_blood_sugar.jpg": "Rn6S",
	"./Hba1c.jpg": "yrqb",
	"./Pulse.png": "8dmw",
	"./Weight.jpg": "clM2",
	"./blood_pressure.png": "KYwm",
	"./pt-dashboard-01.png": "3zU+",
	"./pt-dashboard-02.png": "52KZ",
	"./pt-dashboard-03.png": "Reow",
	"./pt-dashboard-04.png": "cef2",
	"./specialities-01.png": "1FeS",
	"./specialities-02.png": "hKRx",
	"./specialities-03.png": "MTEk",
	"./specialities-04.png": "H4sZ",
	"./specialities-05.png": "VZBi"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Ot3P";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/specialities nonrecursive \.png$|\.jpg$
// module id = Ot3P
// module chunks = 0